// extracted by mini-css-extract-plugin
var _1 = "_W3mZE";
export { _1 as "searchMatch" }
